export const fairTopFeatureTranslationJP = {
  FairTopListPage: {
    head_title: 'サブジャンルフェアTOP設定',
    search: '絞り込み',
    expired_date: '有効期限',
    expired_date_description: '適用期間内の日付で有効なものを表示',
    save: '保存',

    display_order: '表示順',
    move_action: '順位変更',
    subgenre_name: 'サブジャンル名',
    dest1: '第１遷移先',
    dest2: '第２遷移先',
    date_range: '適用期間（開始～終了）',
    no_dest: '遷移無し',

    confirm_change_dest1: '第２遷移先で指定した内容と同じ内容が選択されています。<br/>変更してもよろしいですか？',
    dest1_required: '入力が必要です',
  },
};
